import React, { useEffect, useRef, useState } from "react";
import API from "../api/Api";
import { BASE_URL } from "../api/Api";


const Achievements = () => {
  const sliderRef = useRef(null);
  const [achievements, setAchievements] = useState([]);

  // 🔹 API CALL ONLY
useEffect(() => {
  API.get("/achievements")
    .then((res) => {
      const apiData = res.data.data || [];

      const mappedData = apiData.map((item, index) => ({
        year: item.year,
        title: item.title,
        desc: item.description,
        image: item.image, 
        color: index % 2 === 0 ? "bg-primary" : "bg-success",
      }));

      setAchievements(mappedData);
    })
    .catch((error) => {
      console.error("Achievements API Error", error);
    });
}, []);


  // 🔹 AUTO SCROLL (UNCHANGED)
  useEffect(() => {
    if (!sliderRef.current || achievements.length === 0) return;

    const slider = sliderRef.current;
    let scrollSpeed = 2;
    let animationId;

    const autoScroll = () => {
      slider.scrollLeft += scrollSpeed;

      if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
        slider.scrollLeft = 0;
      }

      animationId = requestAnimationFrame(autoScroll);
    };

    animationId = requestAnimationFrame(autoScroll);

    const stopScroll = () => cancelAnimationFrame(animationId);
    const startScroll = () => {
      animationId = requestAnimationFrame(autoScroll);
    };

    slider.addEventListener("mouseenter", stopScroll);
    slider.addEventListener("mouseleave", startScroll);

    return () => {
      cancelAnimationFrame(animationId);
      slider.removeEventListener("mouseenter", stopScroll);
      slider.removeEventListener("mouseleave", startScroll);
    };
  }, [achievements]);

  return (
    <section className="achievements-section">
      <div className="container-fluid">

        <div className="text-center mb-5">
          <span className="badge achievement-badge">
            <i className="bi bi-award"></i> OUR ACHIEVEMENTS
          </span>

          <h2 className="achievement-title mt-3">
            Milestones & Recognitions
          </h2>

          <p className="achievement-desc mt-3">
            Lorem ipsum dolor sit amet consectetur. Rhoncus nisi eros tincidunt
            enim dolor quam imperdiet risus viverra.
          </p>
        </div>

        <div className="achievement-slider" ref={sliderRef}>
          {achievements.map((item, index) => (

            <div className="achievement-card" key={index}>
              <div className={`icon-box ${item.color}`}>
  <img
    src={`${BASE_URL}/assets/images/${item.image}`}
    alt={item.title}
    className="achievement-img"
  />
</div>


              <span className="year-badge">{item.year}</span>
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Achievements;
